"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _class, _desc, _value, _class2;

var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n\tbackground: white;\n\twidth: 20em;\n\tpadding: 0.5em 0;\n\tposition: fixed;\n\t", ";\n\tz-index: 1000000000;\n"], ["\n\tbackground: white;\n\twidth: 20em;\n\tpadding: 0.5em 0;\n\tposition: fixed;\n\t", ";\n\tz-index: 1000000000;\n"]),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(["\n\tpadding: 0.5em 1em;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tcursor: pointer;\n\tdisplay: flex;\n\tflex-direction: row;\n\n\t&:hover {\n\t\tbackground: rgba(0, 0, 0, 0.1);\n\t}\n"], ["\n\tpadding: 0.5em 1em;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tcursor: pointer;\n\tdisplay: flex;\n\tflex-direction: row;\n\n\t&:hover {\n\t\tbackground: rgba(0, 0, 0, 0.1);\n\t}\n"]),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(["\n\tmargin-left: 0.5em;\n\tline-height: 1;\n"], ["\n\tmargin-left: 0.5em;\n\tline-height: 1;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _autobindDecorator = require("autobind-decorator");

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _reactOnclickoutside = require("react-onclickoutside");

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _icon = require("./icon");

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var ChevronIcon = function ChevronIcon(props) {
	return _react2.default.createElement(
		"svg",
		(0, _extends3.default)({
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			className: "feather feather-chevron-right"
		}, props),
		_react2.default.createElement("path", {
			d: "M9 18l6-6-6-6"
		})
	);
};

// --------------------------------------------------

var Menu = _styledComponents2.default.div(_templateObject, function (props) {
	var s = _ramda2.default.path(["theme", "functions", "shadow"])(props);
	if (s) {
		return s(2);
	} else {
		return "\n\t\t\t\tbox-shadow:\n\t\t\t\t\t0px\t3px 3px -3px rgba(0, 0, 0, 0.3),\n\t\t\t\t\t0px 3px 6px 3px rgba(0, 0, 0, 0.15);\n\t\t\t";
	}
});

var Option = _styledComponents2.default.div(_templateObject2);

var Label = _styledComponents2.default.span(_templateObject3);

// --------------------------------------------------

var optionCallBackAndClose = function optionCallBackAndClose(close) {
	return function (fn) {
		return function (e) {
			e.preventDefault();
			e.stopPropagation();
			if (fn) {
				fn(e);
			}
			close();
		};
	};
};

var ContextMenu = (0, _reactOnclickoutside2.default)(_class = (_class2 = function (_React$Component) {
	(0, _inherits3.default)(ContextMenu, _React$Component);

	function ContextMenu(props) {
		(0, _classCallCheck3.default)(this, ContextMenu);

		var _this = (0, _possibleConstructorReturn3.default)(this, (ContextMenu.__proto__ || Object.getPrototypeOf(ContextMenu)).call(this, props));

		_this.state = {
			top: true,
			left: true
		};
		return _this;
	}

	(0, _createClass3.default)(ContextMenu, [{
		key: "handleClickOutside",
		value: function handleClickOutside() {
			this.props.close();
		}
	}, {
		key: "menuRef",
		value: function menuRef(el) {
			if (el) {
				var bounds = el.getBoundingClientRect();
				if (bounds.bottom > window.innerHeight) {
					this.setState({ top: false });
				}
				if (bounds.right > window.innerWidth) {
					this.setState({ left: false });
				}
			}
		}
	}, {
		key: "render",
		value: function render() {
			var props = this.props;
			var style = {};
			style.top = this.state.top ? props.y : null;
			style.bottom = this.state.top ? null : window.innerHeight - props.y;
			style.left = this.state.left ? props.x : null;
			style.right = this.state.left ? null : window.innerWidth - props.x;

			var optionCallback = optionCallBackAndClose(props.close);

			return _react2.default.createElement(
				Menu,
				{ style: style, innerRef: this.menuRef },
				props.options.map(function (option, i) {
					return _react2.default.createElement(
						Option,
						{ key: i, onClick: optionCallback(option.fn) },
						_react2.default.createElement(_icon2.default, { icon: option.icon || ChevronIcon }),
						_react2.default.createElement(
							Label,
							null,
							option.label
						)
					);
				})
			);
		}
	}]);
	return ContextMenu;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class2.prototype, "handleClickOutside", [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleClickOutside"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "menuRef", [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class2.prototype, "menuRef"), _class2.prototype)), _class2)) || _class;

exports.default = ContextMenu;

//# sourceMappingURL=contextMenu.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/components/contextMenu.js
// module id = 207
// module chunks = 0